<template>
  <h1 class="title has-text-centered is-spaced">
    <go-to-dashboard-button />

    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    {{
      `${scaleProductsQty} ${$tc(
        "scaleProducts.scaleProduct",
        scaleProductsQty
      )}`
    }}

    <button class="button" @click="$emit('get-scale-products')">
      <b-icon icon="sync-alt"></b-icon>
    </button>

    &nbsp;
    <button class="button" @click="$emit('add-scale-product')">
      <b-icon icon="plus-circle" type="is-primary"></b-icon>
    </button>

    &nbsp;
    <button class="button" @click="downloadScaleProductsReport">
      <b-icon icon="save"></b-icon>
    </button>

    <hr />
  </h1>
</template>

<script>
import { common } from "../../mixins/common";
import { mask } from "../../mixins/mask";
import { responsive } from "../../mixins/responsive";
import goToDashboardButton from "../common/GoToDashboardButton";

export default {
  props: ["scaleProductsQty"],

  mixins: [common, mask, responsive],

  components: {
    goToDashboardButton
  },

  data() {
    return {
      isLoading: false,
      barcode: "",
      productsFilter: "store-products"
    };
  },

  methods: {
    downloadScaleProductsReport() {
      this.isLoading = true;
      this.$store
        .dispatch("downloadScaleProductsReport")
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.barcode-search {
  display: inline-block;
  position: relative;
  top: -0.95rem;
}
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
